module.exports = __webpack_public_path__ + "static/media/Sachin Singh.ceea4d03.png";